// import Vue from "vue";
import store from '../store/index.js'
const route = Object.create(null)
route.install = function (vue) {
  // 第一个字符串是 组件名，第二个是组件路径，第三个是包名(如果不指定则已1.js,2.js....n.js命名)
	// vue.component('home', (resolve) => {require.ensure([], ()=>resolve(require('../components/HelloWorld.vue')), 'HelloWorld')})
	vue.component('home', (resolve) => {require.ensure([], ()=>resolve(require('../components/home.vue')), 'home')})
	vue.component('pursh', (resolve) => {require.ensure([], ()=>resolve(require('../components/Pursh/Pursh.vue')), 'pursh')})
	vue.component('EDIDetail', (resolve) => {require.ensure([], ()=>resolve(require('../components/EDI/detail.vue')), 'EDIDetail')})
	
	vue.component('transform', (resolve) => {require.ensure([], ()=>resolve(require('../components/transform/transform.vue')), 'transform')})
	vue.component('importTrans', (resolve) => {require.ensure([], ()=>resolve(require('../components/transform/importTrans.vue')), 'importTrans')})
	vue.component('report', (resolve) => {require.ensure([], ()=>resolve(require('../components/reports/reports.vue')), 'report')})
	vue.component('frmReport', (resolve) => {require.ensure([], ()=>resolve(require('../components/reports/frmReport.vue')), 'frmReport')})
	vue.component('asn', (resolve) => {require.ensure([], ()=>resolve(require('../components/ASN/ASN.vue')), 'asn')})
	vue.component('asnDetail', (resolve) => {require.ensure([], ()=>resolve(require('../components/ASN/detail.vue')), 'asnDetail')});
	
	
	vue.component('userManager', (resolve) => {require.ensure([], ()=>resolve(require('../components/SYSSET/userManager.vue')), 'userManager')});
	vue.component('fileSet', (resolve) => {require.ensure([], ()=>resolve(require('../components/SYSSET/fileSet.vue')), 'fileSet')});
	vue.component('passset', (resolve) => {require.ensure([], ()=>resolve(require('../components/SYSSET/PASSSET.vue')), 'passset')});
	
}


export default route